const headerData = [
  { prop: 'StatusName', label: '状态', columnwidth: 80 },
  { prop: 'DocNo', label: '退回处理单号', columnwidth: 140 },
  { prop: 'LineNumber', label: '退回处理单行号', columnwidth: 140 },
  { prop: 'ReturnDate', label: '退货日期', columnwidth: 160 },
  { prop: 'RecordUpdateDate', label: '记录更新日期', columnwidth: 180 },
  { prop: 'Distributor', label: '分销商（归创 / 通桥）', columnwidth: 180 },
  { prop: 'CustomerName', label: '客户名称', columnwidth: 174 },
  { prop: 'CustomerCode', label: '客户编号', columnwidth: 120 },
  { prop: 'CreatedBy', label: '制单人', columnwidth: 150 },
  { prop: 'CreateTime', label: '创建时间', columnwidth: 140 },
  { prop: 'ProductModel', label: '产品型号', columnwidth: 140 },
  { prop: 'ProductName', label: '产品名称', columnwidth: 260 },
  { prop: 'ProductCode', label: '产品编码', columnwidth: 120 },
  { prop: 'BatchNumber', label: '批号', columnwidth: 120 },
  { prop: 'ExpiryDate', label: '有效期至', columnwidth: 140 },
  { prop: 'Unit', label: '单位', columnwidth: 70 },
  { prop: 'ReturnQty', label: '退货数量', columnwidth: 100 },
  { prop: 'OrderPrice', label: '单价', columnwidth: 100 },
  { prop: 'ShipmentDate', label: '发货日期', columnwidth: 160 },
  { prop: 'HeaderRemark', label: '表头备注', columnwidth: 180 },
  { prop: 'LineRemark', label: '表体备注', columnwidth: 100 },
  { prop: 'OriginalCurrencyTotalWithTax', label: '原币价税合计', columnwidth: 110 },
  { prop: 'ShipDocNo', label: '出货单号', columnwidth: 120 },
  { prop: 'ShipDocLineNo', label: '出货单行号', columnwidth: 120 },
  { prop: 'Auditor', label: '审核人', columnwidth: 100 },
  { prop: 'AuditTime', label: '审核时间', columnwidth: 170 },
  { prop: 'OriginalCurrencyUnitPriceWithoutTax', label: '原币无税单价', columnwidth: 110 },
  { prop: 'OriginalCurrencyTaxAmount', label: '原币税额', columnwidth: 100 },
  { prop: 'OriginalCurrencyAmount', label: '原币金额', columnwidth: 100 },
  { prop: 'LocalCurrencyUnitPriceWithoutTax', label: '本币无税单价', columnwidth: 110 },
  { prop: 'LocalCurrencyAmount', label: '本币金额', columnwidth: 100 },
  { prop: 'LocalCurrencyTaxAmount', label: '本币税额', columnwidth: 100 },
  { prop: 'Currency', label: '币种', columnwidth: 80 },
  { prop: 'ExchangeRate', label: '汇率', columnwidth: 80 },
  { prop: 'TaxRate', label: '税率', columnwidth: 80 },
  { prop: 'OutboundQuantity', label: '出库数量', columnwidth: 100 },
  { prop: 'InvoiceQuantity', label: '开票数量', columnwidth: 100 },
]
export default headerData
